<template>
  <Card>
    <h1 slot="Title">Cost Element / Commitment Item</h1>
    <div slot="MainContent">
      <p>
        This is an eight-digit code that identifies the nature or the physical characteristics of the expenditure (such as military and civilian pay; travel of personnel; supplies; equipment; rents; utilities, etc.).

      </p>
      <ul>
        <li>
          <b>Cost Element</b> 6100.2617
        </li>
        <ul>
          <li>
            <b>US Standard G/L Account</b> 6100
          </li>
        </ul>
        <li>
          <b>Commitment Item</b>: 2617
        </li>
        <ul>
          <li>
            Object Class: 26
          </li>
          <li>
            Additional Specific Detail:  17
          </li>
        </ul>
      </ul>
      <p> 202011D20 A76VV 131096QLOG <b><u>6100.2617</u></b> WBS, Internal Order or Cost Center 1000000067 021001</p>
    </div>
    <div slot="Notes">
      <p><strong>Cost Element/ Commitment Item</strong></p>
      <p><strong>&nbsp;</strong></p>
      <p><strong>INSTRUCTOR NOTE: </strong><strong>Refer</strong><strong> students to </strong><strong>page 7 of the summary sheet.</strong></p>
      <p>&nbsp;The first four characters of the cost element are the <strong>General Ledger is</strong> the main accounting record of a business which uses double-entry bookkeeping (balances your debts and credits).&nbsp; It usually include accounts for such as current assets, fixed assets, liabilities, revenue and expenses items, gain and losses.&nbsp; Example:&nbsp; <strong>OMB push money down to this cost object for example object class 26. This money will cover everything in this specific series (Supplies and Materials). </strong>&nbsp;</p>
      <p>&nbsp;</p>
      <p>The first three digits of the Commitment Item are created from the Office of Management and Budget (OMB) defined object class. The 4-character Funds Management (FM) commitment item contains additional detail information beyond the detail directed by OMB. All FM commitment items are tied to an OMB Object Class.</p>
      <p><strong>Cost Element/Commitment Item:&nbsp; 6100.2617</strong></p>
      <p><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </strong><u><strong>Position&nbsp; </strong></u><strong>&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </strong><u><strong>Represents</strong></u><strong>&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </strong><u><strong>Example</strong></u></p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1-4&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; GLAC (general ledger chart of accts)&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 6100 (Operating Expenses)</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5-6&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; OMB 2 Character Object Class&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 26 (Supplies and Materials)</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 7&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Depot Level Reparable&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1 (Depot Level Reparable)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2 (Non-depot Level Reparable)</p>
      <p>&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3 (Unclassified)</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 8&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Material Category&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 7 (Combat Vehicle Repair Parts)</p>
    </div>
  </Card>
</template>

<style scoped>
ul > li {
  margin-bottom: 0;
  list-style-type: hyphen;
}

ul {
  margin-bottom: 18px;
}

</style>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'FunctionalAreaExample',
  
  data() {
    return {
      Image: require('@/assets/Functional_Area_Elements.png')
    }
  }
  
}
</script>